import BillingPage from '../pages/billing';
import ClientCallbackPage from '../pages/callback/callback_client';
import ClientIntegrationPage from '../pages/integrations/client_integration';
import CustomerManagementPage from '../pages/customer_management';
import { protectedRoute } from './';
import ReviewManagementPage from '../pages/review_management';

export const AdminRestrictedRoutes = [
    {
        path: 'billing',
        Component: () => protectedRoute(<BillingPage />, ['companyManager', 'organizationAdmin', 'organizationOwner'])
    },
    {
        path: 'customer-management',
        Component: () => protectedRoute(<CustomerManagementPage />, ['companyManager', 'organizationAdmin', 'organizationOwner'])
    },
    {
        path: 'review-management',
        Component: () => protectedRoute(<ReviewManagementPage />, ['companyManager', 'organizationAdmin', 'organizationOwner'])
    },
    {
        path: 'integration',
        Component: () => protectedRoute(<ClientIntegrationPage />, ['companyManager', 'organizationAdmin', 'organizationOwner'])
    },
    {
        path: 'callback',
        Component: () => protectedRoute(<ClientCallbackPage />, ['companyManager', 'organizationAdmin', 'organizationOwner'])
    }
];